var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15C14.2727 16 23.8333 22.0833 28.4545 25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4551 15C27.1824 16 17.6217 22.0833 13.0005 25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsClose);
export default __webpack_public_path__ + "static/media/notifications-close.09493957e36515a5e5701d3410998e88.svg";
export { ForwardRef as ReactComponent };